export enum BUTTON_ACTIONS {
    FirstPage = "first page",
    LastPage = "last page",
    PreviousPage = "previous page",
    NextPage = "next page"
}
